// extracted by mini-css-extract-plugin
export default {"menu":"NavbarMobile_menu__eEBOA"};